import { Save } from 'lucide-react'
import PageHeader from '../../components/Dashboard/PageHeader'

export default function Settings() {
  return (
    <div>
      <PageHeader
        title="Einstellungen"
        description="Allgemeine Angaben zur Website."
      />

      <div className="rounded-lg border border-gray-800 bg-gray-950 p-5 sm:p-6 max-w-xl">
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-zinc-300 mb-1.5">
              Website-Name
            </label>
            <input
              type="text"
              defaultValue="Hückels May"
              className="w-full h-10 px-3 rounded-lg bg-gray-900 border border-gray-800 text-white text-sm placeholder-zinc-500 outline-none focus:border-brand-700"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-zinc-300 mb-1.5">
              E-Mail
            </label>
            <input
              type="email"
              defaultValue="info@hueckels-may.de"
              className="w-full h-10 px-3 rounded-lg bg-gray-900 border border-gray-800 text-white text-sm placeholder-zinc-500 outline-none focus:border-brand-700"
            />
          </div>
        </div>

        <div className="pt-5 mt-5 border-t border-gray-800">
          <button
            type="button"
            className="inline-flex items-center gap-2 h-9 px-3 rounded-lg bg-brand-800 text-white text-sm font-medium hover:bg-brand-700"
          >
            <Save className="h-4 w-4" />
            Speichern
          </button>
        </div>
      </div>
    </div>
  )
}
